import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import  TariffaButton from '../TariffaButton/TariffaButton'
import TariffaComponent from '../TariffaComponent/TariffaComponent'
 import './TariffaToc.css'
import { connect } from 'react-redux';
import { changepositionEnd,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa, changePositionTariffaStart} from "../../redux";


 function DrawerLeft(props) {
  function ciao2(){
    
    const queryString = window.location.search;
    
    const urlParams = new URLSearchParams(queryString);
    
    if(urlParams.has("tariffe")){
       props.percorsoTariffa.percorsoTariffa = false
       props.percorsoDrawer.percorsoDrawer = true 
       return true;             
      } 
       else {
               return false;
       }
    
/*
    if(queryString === ''){
      props.percorsoDrawer.percorsoDrawer = false
      props.percorsoTariffa.percorsoTariffa = true
            return true;
      } 
      else {
              return false;
      }*/
    
}
  // const classes = useStyles();
  const [open, setOpen] = React.useState(ciao2());
  
  const handleDrawerClose = () => {
    setOpen(false);
    
    
    
    
  };
  return (
    <div className={"root"}>
      
      <TariffaButton openMenu={setOpen} button={props.value.buttonStyle}></TariffaButton>
      
      <Drawer
      transitionDuration={500}
        className={"drawer"}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: "drawerPaper2",
        }}
      >       
         <TariffaComponent data={props.dataList.data} callback={handleDrawerClose.bind(this)} />   

      </Drawer>
    </div>
  );
}
const mapStateToProps = state => {
  return {
      dataList: state.dataList,
      percorsoTariffa :state.percorsoTariffa,
      positionTariffaStart : state.positionTariffaStart,
      positionTariffaEnd : state.positionTariffaEnd,
      percorsoDrawer : state.percorsoDrawer
  }
}
const mapDispatchToProps = dispatch => {
  return { 
      changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
      changePercorsoDrawer: (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
      changePercorsoTariffa:(percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),
      changePositionTariffaStart : (positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
      changePositionTariffaEnd : (positionTariffaEnd) => dispatch(changepositionEnd(positionTariffaEnd))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(DrawerLeft)